<script>
  import Button from "$lib/components/Button.svelte";

  export let pageNum;
  export let testid;
  export let current = false;
  export let arialLabel = null;
  export let haspopup = false;
  export let expanded = false;
</script>

<Button
  variant="ghost"
  size="small"
  class="!px-10 !py-2 !ring-1 hover:!ring-2 focus-visible:!ring-2 !rounded-2 text-size-14 {current
    ? '!bg-cyan-300'
    : ''}"
  on:click
  data-testid={testid}
  aria-label={arialLabel}
  aria-haspopup={haspopup}
  aria-expanded={haspopup ? expanded : null}
>
  {pageNum}
</Button>
